import { render, staticRenderFns } from "./ExampleItineraries.vue?vue&type=template&id=1fc95ec4&scoped=true&"
import script from "./ExampleItineraries.vue?vue&type=script&lang=js&"
export * from "./ExampleItineraries.vue?vue&type=script&lang=js&"
import style0 from "./ExampleItineraries.vue?vue&type=style&index=0&id=1fc95ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc95ec4",
  null
  
)

export default component.exports